import ozSeoWidgetsNeighborhoods from './oz-seo-widgets-neighborhoods.vue'

export default ozSeoWidgetsNeighborhoods
